<template>
<div class="container">
    <div class="content-list" v-if="data.data">

        <div class="item-type">
			<div class="type-name decrypt" :decrypt-text="data.category.name"></div>
			<div class="title-labels">
                <div class="item" v-for="e in $group.getDatas(group.data['107'], 1).concat($group.getDatas(group.data['106'], 4))">
                    <a rel="nofollow noopener" referrerpolicy="no-referrer" target="_blank" @click="$group.clickSk(e.id, e.product_id)" :href="$group.getGGUrl(e)" class="decrypt" :decrypt-text="e.name"></a>
                </div>
            </div>
		</div>
        
        <div class="type-genres" v-if="data.category.genres">
            <router-link v-for="(row, index) in data.category.genres" :key="index" :to="'/genre/'+data.category.id+'_'+row.id+'.htm'" class="decrypt" :decrypt-text="row.name"></router-link>
        </div>

        <div class="label columns8 gap2" v-if="data.category.labels">
            <router-link v-for="(row, index) in data.category.labels" :key="index" v-if="index<24" class="decrypt" :to="'/search.htm?search='+row.name" :decrypt-text="row.name"></router-link>
        </div>

        <!-- 固定位 -->
        <div class="infor_flow" v-if="group.data" v-for="e in $group.getDatas(group.data['103'], 1)">
            <a rel="nofollow noopener" referrerpolicy="no-referrer" target="_blank" @click="$group.clickSk(e.id, e.product_id)" :href="$group.getGGUrl(e)" style="padding: 0px 8px;">
                <img class="lazy-load" :src="group.css_domain+'/'+group.path+'/images/load640.gif?ad'" :data-src="group.pic_domain+(e.picture_url.replace('.css', '.js'))" width="100%">
            </a>
        </div>
        
        <div class="item-lists" v-if="data.data">
            <template v-for="(row, index) in data.data.videos">
                <div class="item-list">
                    <a rel="nofollow noopener" referrerpolicy="no-referrer" target="_blank" v-for="e in $group.getDatas(group.data['107'].concat(group.data['106']), 1)" @click="$group.clickSk(e.id, e.product_id)" :href="$group.getGGUrl(e)" class="list-text"><span class="decrypt" :decrypt-text="e.name"></span></a>
                    <router-link target="_blank" :to="'/video/'+row.id+'.htm'">
                        <div class="item-image">
                            <img class="lozad" :src="group.css_domain+'/'+group.path+'/images/load320.gif?ad'" :data-src="group.pic_domain+'/pic/'+row.serial_number+'/thumbnail.css'"/>
                            <div class="item-image-zhao"></div>
                        </div>
                        <div class="item-tag">
                            <span class="item-date" v-if="row.second">{{row.second}}</span>
                            <span class="item-read">
                                <i class="el-icon-view"></i>
                                <span>{{row.read_number}}</span>
                            </span>
                        </div>
                        <div class="item-title decrypt" :decrypt-text="row.title"></div>
                    </router-link>
                </div>
                <!-- 广告部分 --->
                <div class="item-list" v-if="index==5 || index==13" v-for="e in $group.getDatas(group.data['105'], 2)">
                    <a  rel="nofollow noopener" referrerpolicy="no-referrer" target="_blank" @click="$group.clickSk(e.id, e.product_id)" :href="$group.getGGUrl(e)">
                        <div class="item-image">
                            <img class="lazy-load" :src="group.css_domain+'/'+group.path+'/images/load320.gif?ad'" :data-src="group.pic_domain+(e.picture_url.replace('.css', '.js'))"/>
                            <div class="item-image-zhao"></div>
                        </div>
                        <div class="item-tag">
                            <span class="item-date"></span>
                            <span class="item-read">
                                <i class="el-icon-view"></i>
                                <span>9999</span>
                            </span>
                        </div>
                        <div class="item-title decrypt" :decrypt-text="e.name"></div>
                    </a>
                </div>
            </template>
        </div>

        <div class="page">
            <div class="fan-page">
                <a :href="'/type/'+paramet.category_id+'_'+pagedata.first+'.htm'">首页</a>
                <a :href="'/type/'+paramet.category_id+'_'+pagedata.prev+'.htm'" v-if="pagedata.prev>=1">上一页</a>
                <a :href="'/type/'+paramet.category_id+'_'+pagedata.prev2+'.htm'" v-if="pagedata.prev2>=1 && paramet.page==last">{{pagedata.prev2}}</a>
                <a :href="'/type/'+paramet.category_id+'_'+pagedata.prev+'.htm'" v-if="pagedata.prev>=1">{{pagedata.prev}}</a>
                <a :href="'/type/'+paramet.category_id+'_'+paramet.page+'.htm'" class="action">{{paramet.page}}</a>
                <a :href="'/type/'+paramet.category_id+'_'+pagedata.next+'.htm'" v-if="pagedata.next<=pagedata.last">{{pagedata.next}}</a>
                <a :href="'/type/'+paramet.category_id+'_'+pagedata.next2+'.htm'" v-if="pagedata.next<=pagedata.last && paramet.page==1">{{pagedata.next2}}</a>
                <a :href="'/type/'+paramet.category_id+'_'+pagedata.next+'.htm'" v-if="pagedata.next<=pagedata.last">下一页</a>
                <a :href="'/type/'+paramet.category_id+'_'+pagedata.last+'.htm'">尾页</a>
            </div>
            <div class="sk-page">
				<form :action="'/type/'+paramet.category_id+'_'+pagedata.sk_page+'.htm'" method="GET" id="form_page_sk">
                    <input type="number" inputmode="numeric" pattern="[0-9]*" maxlength="4" v-model="pagedata.sk_page" @blur="inputblur" @focus="_scrollTop(120, 'form_page_sk')" :placeholder="'0-'+pagedata.last">
                    <a :href="'/type/'+paramet.category_id+'_'+pagedata.sk_page+'.htm'">前往</a>
                </form>
                <span>共 <b>{{pagedata.last}}</b> 页</span>
			</div>
        </div>
    </div>
</div>
</template>
<script>
export default {
    name: 'home',
    data: function () { 
        return {
            group: Group,
            paramet: {
                category_id: Math.round(this.$route.params.id),
                page: Math.round(this.$route.params.page),
            },
            pagedata: {
                first: 0,
                prev2: 0,
                prev: 0,
                next: 0,
                next2: 0,
                last: 0,
                sk_page: Math.round(this.$route.params.page),
            },
            data: {},
        }
    },
    created: function () {
        var Th = this;
        Th.$emit('_function', ['tongji', 'lozad', 'lazy-load', 'decrypt', 'show_new_url', 'show_tanchuang0', 'show_tanchuang1']);
        Th.$emit("page", "video_category_"+Math.round(Th.$route.params.id));
        Th.getTypeVideos();
    },
    methods:{
        getTypeVideos: function() {
            var Th = this;
            Th.$emit('_function', ['loading_open','scrollto']); //加载，回到顶部

            if(Number.isNaN(Th.paramet.page) || Th.paramet.page<=1){
                Th.paramet.page = 1;
            }
            
            Th.$api.get('/type/'+Th.paramet.category_id+'_'+Th.paramet.page+'.json?'+Th.group.csstime, {}, function(data){
                Th.data = data;
                Th.setPage(data.data.page_count);
                Th.$emit('_function', ['loading_close', 'lozad','lazy-load','decrypt']);
            }, function(type, message){ Th.$emit('_function', ['loading_close', 'lozad','lazy-load','decrypt']); });
        },
        setPage: function(page_count){
            this.pagedata.first = 1;
            this.pagedata.prev2 = this.paramet.page-2;
            this.pagedata.prev = this.paramet.page-1;	
            this.pagedata.next = this.paramet.page+1;
            this.pagedata.next2 = this.paramet.page+2;
            this.pagedata.last = page_count;
        },
        inputblur(e) {
            var Th = this;
            let val = e.target.value.replace(/[^0-9]/g, '');
            if(val>Th.pagedata.last) {
                Th.pagedata.sk_page = Th.pagedata.last;
            }
            if(val<=0) {
                Th.pagedata.sk_page = 1;
            }
        },
        _scrollTop(height, id)
        {
            var _scrollTop = $(window).scrollTop();
            var _top = $('#'+id).offset().top - _scrollTop;
            if(_top>height)
            {
                var _targetTop = _scrollTop+(_top-height);
                $('html, body').animate({
                    scrollTop: _targetTop
                }, 800);
            }
        }
    },
}
</script>